import React from "react";

import { reactPlugin } from "utils/AppInsightsManager/AppInsightsManager";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

export const WithAppInsightsContext : React.FunctionComponent<{children: React.ReactNode}> = ({children }) => {
  if (!navigator.onLine) {
    return <>{children}</>;
  }
  return (
    <AppInsightsContext.Provider  value={reactPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );

};
